angular.module("propagandaManuscriptControlRouterModule", [])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('front.resourcectrl.propagandamanuscript.manuscriptcontrol', {
            url: '/manuscriptcontrol?groupid',
            views: {
                'resource@front.resourcectrl.propagandamanuscript': {
                    templateUrl: './resourceCenter/propagandaManuscriptControl/propagandaManuscriptControl_tpl.html',
                    controller: 'propagandaManuscriptControlCtrl'
                }
            },
        }).state('propagandamanuscriptdetail', {
            url: '/propagandamanuscriptdetail?detailid&docid',
            views: {
                '': {
                    templateUrl: './resourceCenter/propagandaManuscriptControl/propagandaManuscriptPreview/propagandaManuscriptPreview_tpl.html',
                    controller: 'propagandaManuscriptPreviewCtrl'
                }

            },
            
        });
    }]);